import { useMemo } from 'react';
import { ThemeProvider, createTheme, Palette, ThemeOptions } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import { LoginSource } from '@pages/Login/constants';
import { INSUREON_EVENTS_PRESET_SLUG } from '@/constants/presetSlugs';
import { getComponents } from '@theme/components';
import { FontSize } from '@store/types/UserStoreSlice.type';
import colors from '@theme/colors';

const PRESET_PRIMARY = colors.INSUREON_PRESET_PRIMARY;
const INSUREON_LIGHT = colors.INSUREON_PRESET_LIGHT;
const INSUREON_DARK = colors.INSUREON_PRESET_DARK;

export const PresetSignUpWrapper = ({
  children,
  loginSource,
  redirectUrl,
}: {
  children: React.ReactNode;
  loginSource: LoginSource;
  redirectUrl?: string;
}) => {
  const baseTheme = useTheme();

  const insureonTheme = useMemo(() => {
    const customPalette = {
      ...baseTheme.palette,
      mode: 'light' as const,
      text: {
        ...baseTheme.palette.text,
        primary: '#1C2D40',
        secondary: 'rgba(28,45,64,0.7)',
        disabled: 'rgba(28,45,64,0.4)',
        main: '#1C2D40',
        subdued: 'rgba(28,45,64,0.6)',
        caption: '#222222',
      },
      primary: {
        main: PRESET_PRIMARY,
        light: INSUREON_LIGHT,
        dark: INSUREON_DARK,
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: INSUREON_LIGHT,
        light: INSUREON_LIGHT,
        dark: INSUREON_DARK,
        contrastText: '#FFFFFF',
      },
      button: {
        ...baseTheme.palette.button,
        outlinedDark: INSUREON_DARK,
        outlined: '#FFFFFF',
        tertiary: INSUREON_DARK,
      },
    };

    return createTheme({
      ...baseTheme,
      palette: customPalette,
      components: getComponents('light', customPalette as Palette, FontSize.DEFAULT),
    } as ThemeOptions);
  }, [baseTheme]);

  if (
    loginSource === LoginSource.QUOTE_SETUP_PRESET &&
    new URLSearchParams(redirectUrl?.split('?')[1]).get('preset')?.toLowerCase() === INSUREON_EVENTS_PRESET_SLUG
  ) {
    return <ThemeProvider theme={insureonTheme}>{children}</ThemeProvider>;
  }

  return <>{children}</>;
};
